import type { Dispatch } from 'react';

import type { ContextState } from '../../../types';

export function useBackStep<D>([prevState, dispatch]: [ContextState, Dispatch<D>]): [
  ContextState,
  Dispatch<D>,
] {
  return [
    {
      ...prevState,
      isBackEnabled: prevState.currentStep !== 0,
    },
    dispatch,
  ];
}
